import { useQuery } from 'react-apollo';
import { PRICES_BY_SYSTEM_TYPE } from '../../../../queries';

export const useSFPrices = () => {
  const { data, loading } = useQuery(PRICES_BY_SYSTEM_TYPE, {
    variables: { systemType: 'sf' },
  });

  if (loading) return [];

  return data.pricesBySystemType;
};
